module.exports = __webpack_public_path__ + "img/hw-checkbox03-radio.c047eba2.svg";